import { ConfigProvider, theme as antdTheme } from 'antd';
import type { ReactNode } from 'react';
import { colorTokens } from './tokens';

/**
 * App-wide AntD theme provider.
 * Binds brand colors, typography, spacing and radius tokens once at the root.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider
      theme={{
        algorithm: antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: colorTokens.brandPrimary,
          colorSuccess: colorTokens.success,
          colorWarning: colorTokens.warning,
          colorError: colorTokens.error,
          colorInfo: colorTokens.info,
          colorTextHeading: colorTokens.textHeading,
          colorTextBase: colorTokens.textBody,
          colorBorder: colorTokens.border,
          colorBgLayout: colorTokens.bgLayout,
          colorBgContainer: colorTokens.bgContainer,
          borderRadius: 6,
          fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif",
          fontSize: 14,
        },
        components: {
          Layout: {
            headerBg: colorTokens.bgContainer,
            headerHeight: 56,
            siderBg: colorTokens.bgContainer,
            bodyBg: colorTokens.bgLayout,
          },
          Menu: {
            itemSelectedBg: colorTokens.brandPrimaryBg,
            itemSelectedColor: colorTokens.brandPrimary,
            itemHoverBg: colorTokens.bgLayout,
          },
          Button: {
            controlHeight: 36,
            fontWeight: 500,
          },
          Table: {
            headerBg: '#fafbfc',
            headerColor: colorTokens.textHeading,
            rowHoverBg: '#fafbfc',
          },
          Card: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}